module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_dokfeltoltes1.3f03db03.jpg";